import { Routes, mapToCanActivate } from '@angular/router';
import { coreRoutes } from '@next/core-lib/app';
import { AuthGuard } from '@next/core-lib/authorization';

import { AuthorizationsComponent } from './components/authorizations/authorizations.component';

export const appRoutes: Routes = [
  {
    path: '',
    canActivate: mapToCanActivate([AuthGuard]),
    component: AuthorizationsComponent,
  },
  ...coreRoutes,
];
